import React from "react"
import { Navigate } from "react-router-dom"

import Dashboard from "../pages/Dashboard/index"
import Login from "../pages/Authentication/Login"
import { inventoryRoutes } from "./route/inventory"
import { settingsRoutes } from "./route/settings"
import { procurementRoutes } from "./route/procurement"
import { hrmsRoutes } from "./route/hrms"
import { estimationRoutes } from "./route/estimation"
import { projectManagementRoutes } from "./route/projectManagement"
import Logout from "../pages/Authentication/Logout"
import ModulesIndex from "../pages/modules"
import RolesIndex from "../pages/Roles"
import EditRole from "../pages/Roles/edit"
import { centalStoreRoutes } from "./route/centralStore"
import { financeRoutes } from "./route/finance"
import UserProfile from "../pages/Profile/userProfile/index"
import { hrSelfServiceRoutes } from "./route/hrSelfService"
import { userManagementRoutes } from "./route/userManagement"
import ThemeOptions from "../pages/Themes/themeOption"
import NotFound from "../pages/ErrorPage/notFound"
import NetworkError from "../pages/ErrorPage/networkError"
import NotificationList from "../pages/Notification/listNotification"
import ExpiredNotificationList from "../pages/Notification/listExpiredNotification"
import Dashboardesign from "../pages/Dashboard/dashboardesign"
import { PrivateSettings } from "./route/truncate"

const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  {path: "/dashboardesign", component: <Dashboardesign />},
  { path: "/logout", component: <Logout /> },
  { path: "/profile", component: <UserProfile /> },
  { path: "/theme-options", component: <ThemeOptions /> },
  { path: "/modules", component: <ModulesIndex /> },
  { path: "/roles", component: <RolesIndex /> },
  { path: "/settings-roles/edit/:id", component: <EditRole /> },
  { path: "/settings-roles/add", component: <EditRole /> },
  { path: "/network-error", component: <NetworkError /> },
  { path: "/notification", component: <NotificationList /> },
  { path: "/notification/document-expiry", component: <ExpiredNotificationList /> },
  { path: "*", component: <NotFound /> },
  ...inventoryRoutes,
  ...settingsRoutes,
  ...hrmsRoutes,
  ...procurementRoutes,
  ...estimationRoutes,
  ...projectManagementRoutes,
  ...centalStoreRoutes,
  ...financeRoutes,
  ...hrSelfServiceRoutes,
  ...userManagementRoutes,
  ...PrivateSettings,
]

const authRoutes = [{ path: "/login", component: <Login /> }]

export { userRoutes, authRoutes }
